import React, { FC } from "react";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Twitter: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faTwitter} {...props} />;
};
